module.exports = __webpack_public_path__ + "img/sos_phone.59b77766.svg";